import { Resources, useResource } from "Infrastructure/Translations/Resources";
import { Home } from "Shared/appIcons";
import { UnauthenticatedLayout } from "Shared/Layouts/UnauthenticatedLayout";
import { UnstyledLink } from "Shared/Routing/UnstyledLink";
import { useLocation } from "react-router";
import { Button } from "@/components/ui/button";

export const Error404Page = () => {
	const location = useLocation();
	const { t } = useResource();

	return (
		<UnauthenticatedLayout title={t(Resources.Errors.Error404.Title)}>
			<div className="space-y-4 text-center">
				<h1 className="text-3xl font-bold">
					{t(Resources.Errors.Error404.Title)}
				</h1>
				<p className="text-muted-foreground text-label">{location.pathname}</p>
				<p className="text-lg font-medium">
					{t(Resources.Errors.Error404.Subtitle)}
				</p>
				<UnstyledLink to="/">
					<Button size="lg">
						<Home className="mr-2 h-4 w-4" />
						{t(Resources.Errors.Error404.Home)}
					</Button>
				</UnstyledLink>
			</div>
		</UnauthenticatedLayout>
	);
};
